import React from 'react';
import { Check } from 'lucide-react';
import { featuresData, marketingImages } from '../../data/mock';

const Features = () => {
  return (
    <section id="features" className="py-24 bg-teal-500 relative overflow-hidden">
      {/* Background Decorations */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-white/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Why This Guide Stands Out
          </h2>
          <p className="text-lg text-white/80 max-w-2xl mx-auto">
            Everything you need to start earning, backed by real data and proven strategies
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          {/* Features Grid */}
          <div className="grid gap-4">
            {featuresData.map((feature, idx) => (
              <div
                key={idx}
                className="flex items-start gap-4 bg-white/10 backdrop-blur-sm rounded-2xl p-5 hover:bg-white/15 transition-colors duration-300"
              >
                <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Check className="w-5 h-5 text-teal-600" />
                </div>
                <div>
                  <h3 className="text-white font-semibold text-lg">{feature.title}</h3>
                  <p className="text-white/70 text-sm mt-1">{feature.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Image */}
          <div className="flex justify-center">
            <img 
              src={marketingImages.whatsInside} 
              alt="What's Inside This Guide"
              className="w-full max-w-md rounded-2xl shadow-2xl shadow-black/30"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
